<!--
  Slim bulk-operations bar for the PMA page. Only exposes the two ops we
  want here: Assign To Campaign and Assign To Collection. Reuses the same
  CompanyBulkActions modal so the actual submit flow (AssignCampaignEngine
  on the backend, etc.) stays identical to the Companies page.

  Sibling components like CompanyBulkOperations expose ~20 ops — too noisy
  for this surface. If we ever need more here, add the buttons here
  explicitly rather than reaching for the kitchen-sink component.
-->
<template>
  <div class="justify-center items-center mx-1">
    <div class="flex flex-row justify-between items-center pb-0.5 border-b mx-1.5 border-b-gray-400">
      <h3 class="text-sm">Bulk Operations:</h3>
    </div>
    <div class="flex flex-row flex-wrap items-center pt-1">
      <base-pill-button
        class="m-1 text-xs"
        :class="{ 'opacity-50 cursor-not-allowed': !hasSelection }"
        :disabled="!hasSelection"
        @click="openCampaignAction"
      >
        Assign To Campaign
      </base-pill-button>
      <base-pill-button
        class="m-1 text-xs"
        :class="{ 'opacity-50 cursor-not-allowed': !hasSelection }"
        :disabled="!hasSelection"
        @click="openCollectionAction"
      >
        Assign To Collection
      </base-pill-button>
    </div>

    <base-dialog-box v-if="isModalVisible" @close="closeModal">
      <template #header>
        <h2>Bulk Action: {{ bulkActionTitle }}</h2>
      </template>
      <template #body>
        <company-bulk-actions
          :title="bulkActionTitle"
          :endpoint="bulkActionEndpoint"
          :selectedCompanies="selectedCompanies"
          :campaigns="campaigns"
          :collectionTags="collectionTags"
          @close-modal="closeModal"
          @refetch-companies="$emit('refetch-companies')"
          @clear-selected-companies="$emit('clear-selected-companies')"
          @reset-select-all="$emit('reset-select-all')"
        />
      </template>
    </base-dialog-box>
  </div>
</template>


<script setup>
import { ref, computed, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";

import CompanyBulkActions from "@/components/CompanyBulkActions.vue";
import { getMinimalCollectionTags } from "@/services/CollectionTag";
import { getCampaigns } from "@/services/Campaign";


const props = defineProps({
  selectedCompanies: { type: Array, required: true },
  collectionTags: { type: Array, required: false },
  campaigns: { type: Array, required: false },
});

const hasSelection = computed(() => props.selectedCompanies.length > 0);
const emit = defineEmits(["refetch-companies", "clear-selected-companies", "reset-select-all", "load-campaigns", "load-collection-tags"]);

const store = useStore();

const isModalVisible = ref(false);
const bulkActionTitle = ref(null);
const bulkActionEndpoint = ref(null);
// const campaigns = ref([]);
// const collectionTags = ref([]);


function closeModal() {
  isModalVisible.value = false;
}

function reloadCampaigns(){
  emit("load-campaigns")
}

function reloadCollectionTags(){
  emit("load-collection-tags")
}

async function openCampaignAction() {
  if (!props.selectedCompanies.length) return;
  bulkActionTitle.value = "Assign To Campaign";
  bulkActionEndpoint.value = "bulk_assign_to_campaign";
  const token = store.getters["auth/showToken"];
  // campaigns.value = await getCampaigns(token);
  reloadCampaigns()
  isModalVisible.value = true;
}

async function openCollectionAction() {
  if (!props.selectedCompanies.length) return;
  bulkActionTitle.value = "Assign To Collection";
  bulkActionEndpoint.value = "bulk_assign_collection_tag";
  const token = store.getters["auth/showToken"];
  // collectionTags.value = await getMinimalCollectionTags(token);
  reloadCollectionTags()
  isModalVisible.value = true;
}
</script>
